import React from 'react';
import { AlertDialogCloseButton as ChakraDialogCloseButton } from '@chakra-ui/react';

export function AlertDialogCloseButton() {
  return <ChakraDialogCloseButton />;
}
